import React from "react";
var __jsx = React.createElement;
import PriceOfferProgressBar from "@/pages/price-offer/components/PriceOfferProgressBar";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@i18n";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import { useLang } from "@/common/Contexts/LanguageContext";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import useHelpers from "@hooks/useHelpers";
import PriceOfferCitySearchRenderer from "@/pages/price-offer/components/PriceOfferCitySearchRenderer";
var PriceOfferInspectionLocationSinglePage = function PriceOfferInspectionLocationSinglePage() {
  var _selectedCity$inspect, _selectedCity$inspect2, _selectedCity$inspect3, _selectedCity$inspect4, _selectedCity$inspect5;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _usePriceOfferContext = usePriceOfferContext(),
    state = _usePriceOfferContext.state;
  var _usePriceOfferContext2 = usePriceOfferContext(),
    actions = _usePriceOfferContext2.actions,
    helpers = _usePriceOfferContext2.helpers,
    selectedCity = _usePriceOfferContext2.selectedCity,
    constants = _usePriceOfferContext2.constants;
  var language = useLang();
  var isMobile = useIsMobile();
  var screenState = useBoolean();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var handleLocationChange = function handleLocationChange(event) {
    var value = event.target.value;
    actions.updateCompanyLocation(value);
  };
  var handleLocationSelection = function handleLocationSelection() {
    navigateTo(constants.inspection_date_url(state === null || state === void 0 ? void 0 : state.request_id));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pt-5"
  }, /*#__PURE__*/React.createElement(PriceOfferProgressBar, null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-start text-lg font-bold"
  }, tShort("price_offer/inspection_location_title_single", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-gainsboro border-solid rounded-lg p-4 overflow-hidden flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded-full bg-[#e1ebfd] p-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--location-on-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#2885FC]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-neutral-30 text-xs font-normal leading-4"
  }, tShort("price_offer/inspection_location_subtitle", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-90 text-sm font-bold leading-6"
  }, helpers.getSelectedCityName))), /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-xs font-semibold leading-6 cursor-pointer",
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.currentTarget.click();
      }
    },
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      screenState.setTrue();
    }
  }, tShort("price_offer/location_change_cta", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-px bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-neutral-90 font-bold text-sm"
  }, selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$inspect = selectedCity.inspection_location) === null || _selectedCity$inspect === void 0 ? void 0 : (_selectedCity$inspect2 = _selectedCity$inspect[0]) === null || _selectedCity$inspect2 === void 0 ? void 0 : _selectedCity$inspect2.location_name_ar), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-xs font-medium"
  }, selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$inspect3 = selectedCity.inspection_location) === null || _selectedCity$inspect3 === void 0 ? void 0 : (_selectedCity$inspect4 = _selectedCity$inspect3[0]) === null || _selectedCity$inspect4 === void 0 ? void 0 : _selectedCity$inspect4.location_description_ar))))), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 w-full left-0 px-4 py-6 md:relative md:p-0 md:pt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col gap-4 md:flex-row-reverse md:gap-3 md:justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("transition-colors duration-200 ease-in", "w-full p-3 bg-primary text-white rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer hover:bg-primary-120 transition-colors duration-200 ease-in", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none"),
    disabled: !(((_selectedCity$inspect5 = selectedCity.inspection_location) === null || _selectedCity$inspect5 === void 0 ? void 0 : _selectedCity$inspect5.length) > 0),
    onClick: function onClick() {
      handleLocationSelection();
    }
  }, tShort("price_offer/offer_confirm_inspection", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement(PriceOfferCitySearchRenderer, {
    screenState: screenState
  })));
};
export default PriceOfferInspectionLocationSinglePage;